"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4223],{

/***/ 6603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44012);


var RecaptchaBranding = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: "form-recaptcha-protected-by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                href: "https://policies.google.com/privacy",
                className: "link text-decoration-none",
                target: "_blank",
                rel: "noreferrer",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        id: "form-recaptcha-privacy-policy"
                    })
                ]
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: "form-recaptcha-and"
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://policies.google.com/terms",
                className: "link",
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    id: "form-recaptcha-terms"
                })
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: "form-recaptcha-apply"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RecaptchaBranding);


/***/ }),

/***/ 44223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ requestcallback_modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/helper/wordReplace.tsx
var wordReplace = __webpack_require__(27147);
// EXTERNAL MODULE: ./src/services/callback/index.ts
var callback = __webpack_require__(80244);
// EXTERNAL MODULE: ./src/services/callback/make-request.ts
var make_request = __webpack_require__(21053);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
// EXTERNAL MODULE: ./src/components/callback-modal/recaptcha-branding.tsx
var recaptcha_branding = __webpack_require__(6603);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./public/images/img-depotium-thankyou.svg
/* harmony default export */ var img_depotium_thankyou = ({"src":"/_next/static/media/img-depotium-thankyou.a62c285e.svg","height":226,"width":202});
;// CONCATENATED MODULE: ./src/components/callback-modal/thankyou-content.tsx





var ThankyouContent = function(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? constants/* PHONE_NUMBERS.SELF_STORAGE */.uV.SELF_STORAGE : _phoneNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                sizes: "(max-width: 375px) 180px, (max-width: 576px) 180px, (max-width: 768px) 180px, (max-width: 992px) 200px, (max-width: 1280px) 200px",
                src: img_depotium_thankyou,
                className: "img-fluid center-block mx-auto mt-4",
                alt: "success-img",
                width: "200",
                height: "300"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-heading mt-3 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "thank-you-success-modal"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "para m-2 mx-md-5 mb-md-4 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "form.thankyouMessage",
                    values: {
                        phone_number: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: phoneNumber
                        })
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var thankyou_content = (ThankyouContent);

;// CONCATENATED MODULE: ./src/components/callback-modal/requestcallback-modal.tsx



















var CallbackModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var facilityId = props.facilityId, unitRate = props.unitRate, unitDimensions = props.unitDimensions, ero = props.ero, unitTypeId = props.unitTypeId, PromotionSLName = props.PromotionSLName, promotionDescription = props.promotionDescription, consessionId = props.consessionId, unitWidth = props.unitWidth, unitLength = props.unitLength, formType = props.formType, _storeType = props.storeType, storeType = _storeType === void 0 ? "ss" : _storeType;
    var ref7 = (0,react.useState)(""), onChangeValue = ref7[0], setOnChangeValue = ref7[1];
    var path =  true && window && window.location && (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    var ref8 = (0,react.useState)(""), isModalClose = ref8[0], setIsModalClose = ref8[1];
    var recaptchaRef = (0,react.useRef)(null);
    var locale = (0,next_router.useRouter)().locale;
    var fillTimer;
    var ref9 = (0,react.useState)(false), loading = ref9[0], setLoading = ref9[1];
    var ref10 = (0,react.useState)(""), responseType = ref10[0], setResponseType = ref10[1];
    var ref11 = (0,react.useState)(constants/* PHONE_NUMBERS.SELF_STORAGE */.uV.SELF_STORAGE), phoneNumberRC = ref11[0], setphoneNumberRC = ref11[1];
    var ref12 = (0,index_esm/* useForm */.cI)(), register = ref12.register, handleSubmit = ref12.handleSubmit, reset = ref12.reset, control = ref12.control, errors = ref12.formState.errors;
    var router = (0,next_router.useRouter)();
    var ref13 = (0,react.useState)(), selectedDate = ref13[0], setSelectedDate = ref13[1];
    var networkError = function(error) {
        setResponseType("error");
        console.log("Error", error);
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var token, action, request, response, ref, error, request1, response1, ref1, ref2, ref3, redirectUrl, error1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!data) return [
                            3,
                            10
                        ];
                        // eslint-disable-next-line no-param-reassign
                        data.date = selectedDate ? moment_default()(selectedDate).format("YYYY-MM-DD") : moment_default()(new Date()).format("YYYY-MM-DD");
                        token = data.token, action = data.action;
                        if (!(storeType === "valet")) return [
                            3,
                            6
                        ];
                        request = (0,make_request/* makeValetServiceRequest */.AY)(data, token, path, unitDimensions, unitRate, locale);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,callback/* callbackValetServiceApis */.RJ)(request)
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status !== 200) {
                            ;
                            throw new Error("API Error: ".concat((ref = response.data) === null || ref === void 0 ? void 0 : ref.message));
                        } else {
                            setResponseType("success");
                            window.dataLayer.push({
                                event: "CallBack"
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        networkError(error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            3,
                            10
                        ];
                    case 6:
                        request1 = (0,make_request/* makeCallBackRequest */.T9)(data, token, path, facilityId, unitRate, unitDimensions, ero, locale, unitTypeId, PromotionSLName, promotionDescription, consessionId, unitWidth, unitLength, storeType, action);
                        _state.label = 7;
                    case 7:
                        _state.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            (0,callback/* callbackCallMeApis */.X6)(request1, formType, storeType)
                        ];
                    case 8:
                        response1 = _state.sent();
                        if (response1.status !== 200) {
                            ;
                            throw new Error("API Error: ".concat((ref1 = response1.data) === null || ref1 === void 0 ? void 0 : ref1.message));
                        } else {
                            ;
                            redirectUrl = (response1 === null || response1 === void 0 ? void 0 : (ref2 = response1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.result) === null || ref3 === void 0 ? void 0 : ref3.redirectURL) || null;
                            if (redirectUrl && redirectUrl.length) {
                                clearTimeout(fillTimer);
                                setResponseType("redirect");
                                router.push(redirectUrl);
                            } else {
                                setResponseType("success");
                                setLoading(false);
                            }
                            if (formType === "reserve") {
                                window.dataLayer.push({
                                    event: "Reserve"
                                });
                            // window.gtag('event', `Reserve - ${promotionDescription}`);
                            } else {
                                window.dataLayer.push({
                                    event: "CallBack"
                                });
                            // window.gtag('event', `CallBack - ${promotionDescription}`);
                            }
                        }
                        return [
                            3,
                            10
                        ];
                    case 9:
                        error1 = _state.sent();
                        networkError(error1);
                        setLoading(false);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var hideModal = function() {
        setIsModalClose("modal");
    };
    var handleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var action;
            return (0,tslib_es6.__generator)(this, function(_state) {
                action = formType !== "" ? formType : "request";
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute(constants/* GOOGLE_SITE_LINK_KEY */.HW, {
                        action: action
                    }).then(function(token) {
                        setLoading(true);
                        onSubmit((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            token: token,
                            action: action
                        }));
                        fillTimer = window.setTimeout(hideModal, 2000);
                    });
                });
                return [
                    2
                ];
            });
        });
        return function handleClick(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadRecaptchaScript = function() {
        var script = document.createElement("script");
        script.src = constants/* RECAPTCH_URL */.Yv;
        script.async = true;
        document.body.appendChild(script);
        recaptchaRef.current = true;
    };
    // Phone Number validation
    var handleChange = function(event) {
        var value = event.target.value;
        if (value.length <= 10 && ((0,utility/* allowNumbers */.mK)(value) || value === "")) {
            setOnChangeValue(value);
            window.phone = value;
        }
        if (!recaptchaRef.current) {
            loadRecaptchaScript();
        }
    };
    var handleEmailChange = function(event) {
        var value = event.target.value;
        if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
            window.email = value;
        }
    };
    // eslint-disable-next-line react/display-name
    var CustomInput = /*#__PURE__*/ (0,react.forwardRef)(// eslint-disable-next-line @typescript-eslint/no-shadow
    function(props, ref) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            forwardRef: ref,
            readOnly: true
        }));
    });
    (0,react.useEffect)(function() {
        switch(storeType){
            case "ss":
                return setphoneNumberRC(constants/* PHONE_NUMBERS.SELF_STORAGE */.uV.SELF_STORAGE);
            case "valet":
                return setphoneNumberRC(constants/* PHONE_NUMBERS.VALET_SERVICE */.uV.VALET_SERVICE);
            case "ps":
                return setphoneNumberRC(constants/* PHONE_NUMBERS.PORTABLE_STORAGE */.uV.PORTABLE_STORAGE);
            default:
                return setphoneNumberRC(constants/* PHONE_NUMBERS.SELF_STORAGE */.uV.SELF_STORAGE);
        }
    }, []);
    (0,react.useEffect)(function() {
        setResponseType("");
        setIsModalClose("");
        setLoading(false);
        reset({
            fullName: "",
            email: "",
            description: "",
            phone: null
        });
    }, [
        props
    ]);
    var isFormEntryScreen = !loading && (responseType === "" || responseType === "error");
    var ModalHeadline = function() {
        var modalTitle = function() {
            if (promotionDescription) {
                return (0,wordReplace/* toSentenceCase */.wR)(promotionDescription);
            }
            if (formType === "reserve") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "form.reserveHeader"
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "form.callbackHeader"
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-100 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "modal-title pt-2 mb-md-2",
                    id: "modalLabel",
                    children: modalTitle()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-xs-2 m-0 small-text",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "form.message"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sv-modal-popups",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal fade",
            id: "requestCallbackModal",
            "aria-labelledby": "modalLabel",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-dialog modal-dialog-centered ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-header px-0 pb-2 ",
                            children: [
                                isFormEntryScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn-close",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                })
                            ]
                        }),
                        isFormEntryScreen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "modal-body",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "sv-modal-form",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        placeholder: locale === "en" ? constants/* PLACEHOLDERS.EN.FULLNAME */.Hj.EN.FULLNAME : constants/* PLACEHOLDERS.FR.FULLNAME */.Hj.FR.FULLNAME,
                                                        type: "text",
                                                        className: "form-control ".concat((errors === null || errors === void 0 ? void 0 : errors.fullName) && " error")
                                                    }, register("fullName", {
                                                        required: locale === "en" ? constants/* FORM_ERRORS.EN.FULLNAME */.W_.EN.FULLNAME : constants/* FORM_ERRORS.FR.FULLNAME */.W_.FR.FULLNAME,
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]{0,50}$/,
                                                            message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_CHARS */.W_.EN.ENTER_CHARS : constants/* FORM_ERRORS.FR.FULLNAME */.W_.FR.FULLNAME
                                                        }
                                                    }))),
                                                    ((ref1 = errors.fullName) === null || ref1 === void 0 ? void 0 : ref1.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref2 = errors.fullName) === null || ref2 === void 0 ? void 0 : ref2.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        placeholder: locale === "en" ? constants/* PLACEHOLDERS.EN.EMAIL */.Hj.EN.EMAIL : constants/* PLACEHOLDERS.FR.EMAIL */.Hj.FR.EMAIL,
                                                        type: "email",
                                                        id: "email",
                                                        className: "form-control ".concat((errors === null || errors === void 0 ? void 0 : errors.email) && " error")
                                                    }, register("email", {
                                                        onChange: function(e) {
                                                            return handleEmailChange(e);
                                                        },
                                                        required: locale === "en" ? constants/* FORM_ERRORS.EN.EMAIL */.W_.EN.EMAIL : constants/* FORM_ERRORS.FR.EMAIL */.W_.FR.EMAIL,
                                                        pattern: {
                                                            value: /^\S+@\S+$/i,
                                                            message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_VALID */.W_.EN.ENTER_VALID : constants/* FORM_ERRORS.FR.EMAIL */.W_.FR.EMAIL
                                                        }
                                                    }))),
                                                    ((ref3 = errors.email) === null || ref3 === void 0 ? void 0 : ref3.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref4 = errors.email) === null || ref4 === void 0 ? void 0 : ref4.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        placeholder: locale === "en" ? constants/* PLACEHOLDERS.EN.PHONE */.Hj.EN.PHONE : constants/* PLACEHOLDERS.FR.PHONE */.Hj.FR.PHONE,
                                                        type: "tel",
                                                        id: "phone",
                                                        className: "form-control ".concat((errors === null || errors === void 0 ? void 0 : errors.phone) && " error"),
                                                        value: onChangeValue
                                                    }, register("phone", {
                                                        onChange: function(e) {
                                                            return handleChange(e);
                                                        },
                                                        required: locale === "en" ? constants/* FORM_ERRORS.EN.PHONE */.W_.EN.PHONE : constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE,
                                                        pattern: {
                                                            value: /^(?![01])[0-9]{10}$/,
                                                            message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE : constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE
                                                        }
                                                    }))),
                                                    ((ref5 = errors.phone) === null || ref5 === void 0 ? void 0 : ref5.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref6 = errors.phone) === null || ref6 === void 0 ? void 0 : ref6.message
                                                    })
                                                ]
                                            }),
                                            formType === "reserve" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                        control: control,
                                                        name: "date",
                                                        rules: {
                                                            required: true
                                                        },
                                                        render: function(param) {
                                                            var field = param.field;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((react_datepicker_min_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                className: "form-control ".concat((errors === null || errors === void 0 ? void 0 : errors.date) ? " error" : " movein-date"),
                                                                value: selectedDate
                                                            }, register("date")), {
                                                                onChange: function(date) {
                                                                    field.onChange(date);
                                                                    setSelectedDate(date);
                                                                },
                                                                selected: field.value,
                                                                minDate: moment_default()().toDate(),
                                                                dateFormat: "yyyy-MM-dd",
                                                                showPopperArrow: false,
                                                                placeholderText: locale === "en" ? constants/* PLACEHOLDERS.EN.MOVEIN_DATE */.Hj.EN.MOVEIN_DATE : constants/* PLACEHOLDERS.FR.MOVEIN_DATE */.Hj.FR.MOVEIN_DATE,
                                                                fixedHeight: true,
                                                                calendarClassName: "custom-datepicker",
                                                                withPortal: true,
                                                                onKeyDown: function(e) {
                                                                    e.preventDefault();
                                                                },
                                                                customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {})
                                                            }));
                                                        }
                                                    }),
                                                    errors.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "form.moveInDateRequired"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "form-group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    placeholder: locale === "en" ? constants/* PLACEHOLDERS.EN.MESSAGE */.Hj.EN.MESSAGE : constants/* PLACEHOLDERS.FR.MESSAGE */.Hj.FR.MESSAGE,
                                                    type: "textarea",
                                                    className: "form-control"
                                                }, register("description", {})))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "modal-footer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn dp-primary-btn m-0 w-100 submit-btn",
                                            type: "submit",
                                            onClick: handleSubmit(handleClick),
                                            "data-bs-dismiss": isModalClose,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "".concat(formType === "reserve" ? "Reserve" : "callMeBack")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-3 mt-md-4 mb-md-3 small-text",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "form.modalNote",
                                                values: {
                                                    phone_number: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        children: phoneNumberRC
                                                    })
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "recaptcha-note",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(recaptcha_branding/* default */.Z, {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        (loading || responseType === "redirect") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex justify-content-center my-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border text-primary",
                                        role: "status",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Loading..."
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "ero-loading-message"
                                    })
                                })
                            ]
                        }),
                        !loading && responseType === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(thankyou_content, {
                                phoneNumber: phoneNumberRC
                            })
                        }),
                        !loading && responseType === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "error-msg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "form.thereWasAnErrorSubmittingYourRequest"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var requestcallback_modal = (CallbackModal);


/***/ }),

/***/ 80244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ callbackSmallBusinessApis; },
/* harmony export */   "RJ": function() { return /* binding */ callbackValetServiceApis; },
/* harmony export */   "X6": function() { return /* binding */ callbackCallMeApis; },
/* harmony export */   "_B": function() { return /* binding */ callbackTeamCanadaApis; },
/* harmony export */   "il": function() { return /* binding */ referralCallApis; },
/* harmony export */   "y": function() { return /* binding */ callbackContactUsApis; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var callbackContactUsApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_POST_API */ .y$), "post", data)
            ];
        });
    });
    return function callbackContactUsApis(data) {
        return _ref.apply(this, arguments);
    };
}();
var callbackValetServiceApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_POST_API */ .DW), "post", data)
            ];
        });
    });
    return function callbackValetServiceApis(data) {
        return _ref.apply(this, arguments);
    };
}();
var callbackCallMeApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data, formType) {
        var storeType;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            storeType = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "ss";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getcallMebackUrl */ .mG(formType, storeType)), "post", data)
            ];
        });
    });
    return function callbackCallMeApis(data, formType) {
        return _ref.apply(this, arguments);
    };
}();
var callbackSmallBusinessApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .SMALL_BUSINESS_POST_API */ .Qp), "post", data)
            ];
        });
    });
    return function callbackSmallBusinessApis(data) {
        return _ref.apply(this, arguments);
    };
}();
var callbackTeamCanadaApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .TEAM_CANADA_POST_API */ .k2), "post", data)
            ];
        });
    });
    return function callbackTeamCanadaApis(data) {
        return _ref.apply(this, arguments);
    };
}();
var referralCallApis = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .REFERRAL_POST_API */ .q8, "post", data)
            ];
        });
    });
    return function referralCallApis(data) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 21053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ makeRequest; },
/* harmony export */   "AY": function() { return /* binding */ makeValetServiceRequest; },
/* harmony export */   "Sj": function() { return /* binding */ makeSmallBusinessRequest; },
/* harmony export */   "T9": function() { return /* binding */ makeCallBackRequest; },
/* harmony export */   "UP": function() { return /* binding */ makeTeamCanadaRequest; },
/* harmony export */   "cU": function() { return /* binding */ makeReferralRequest; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13135);

/* eslint-disable*/ 
/* Contact US form */ var makeRequest = function(formData, token, path) {
    var inquiry = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, existing = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, partnership = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, job = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, locale = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "fr", facilityId = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "L022", previousRoute = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : "https://www.depotium.com/en/", type = arguments.length > 10 ? arguments[10] : void 0;
    var ref;
    var invendr =  true && window.invendrData;
    return {
        email: formData === null || formData === void 0 ? void 0 : formData.email,
        newInquiry: inquiry,
        existingClient: existing,
        partnershipInquiry: partnership,
        jobInquiry: job,
        fullName: formData === null || formData === void 0 ? void 0 : formData.fullName,
        preferredContactMethod: formData === null || formData === void 0 ? void 0 : formData.prefer,
        formURL: path,
        previousUrl: previousRoute,
        invendrDetails: {
            callpotentialLeadSource: (invendr === null || invendr === void 0 ? void 0 : invendr.active_rule) || "",
            mediaNumber: ((ref = document.querySelector(".headerPhone")) === null || ref === void 0 ? void 0 : ref.innerText) || "",
            invendrSource: (invendr === null || invendr === void 0 ? void 0 : invendr.source) || "",
            invendrCampaign: (invendr === null || invendr === void 0 ? void 0 : invendr.campaign) || "",
            invendrMedium: (invendr === null || invendr === void 0 ? void 0 : invendr.medium) || "",
            invendrContent: (invendr === null || invendr === void 0 ? void 0 : invendr.content) || "",
            invendrTerm: (invendr === null || invendr === void 0 ? void 0 : invendr.term) || ""
        },
        message: (formData === null || formData === void 0 ? void 0 : formData.description) || (formData === null || formData === void 0 ? void 0 : formData.note),
        phone: formData === null || formData === void 0 ? void 0 : formData.phone,
        preferredLanguage: locale,
        reCaptchaAction: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECAPTCHA_CONTACT_US */ .LV,
        reCaptchaToken: token,
        facilityId: facilityId,
        type: type,
        company: formData === null || formData === void 0 ? void 0 : formData.company
    };
};
/* Small Business form */ var makeSmallBusinessRequest = function(data, token, path) {
    var locale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "fr", facilityId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "L022";
    var ref;
    var invendr =  true && window.invendrData;
    return {
        email: data === null || data === void 0 ? void 0 : data.email,
        fullName: data === null || data === void 0 ? void 0 : data.fullName,
        formURL: path,
        invendrDetails: {
            callpotentialLeadSource: (invendr === null || invendr === void 0 ? void 0 : invendr.active_rule) || "",
            mediaNumber: ((ref = document.querySelector(".headerPhone")) === null || ref === void 0 ? void 0 : ref.innerText) || "",
            invendrSource: (invendr === null || invendr === void 0 ? void 0 : invendr.source) || "",
            invendrCampaign: (invendr === null || invendr === void 0 ? void 0 : invendr.campaign) || "",
            invendrMedium: (invendr === null || invendr === void 0 ? void 0 : invendr.medium) || "",
            invendrContent: (invendr === null || invendr === void 0 ? void 0 : invendr.content) || "",
            invendrTerm: (invendr === null || invendr === void 0 ? void 0 : invendr.term) || ""
        },
        inquiryType: data === null || data === void 0 ? void 0 : data.inquiryType,
        company: data === null || data === void 0 ? void 0 : data.company,
        phone: data === null || data === void 0 ? void 0 : data.phone,
        preferredLanguage: locale,
        reCaptchaAction: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECAPTCHA_SMALL_BUSINESS */ .Kl,
        reCaptchaToken: token,
        facilityId: facilityId
    };
};
/* ValetService form */ var makeValetServiceRequest = function(data, token, path, unitDimensions, unitRate) {
    var locale = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "fr";
    var ref;
    var invendr =  true && window.invendrData;
    return {
        dateNeeded: (data === null || data === void 0 ? void 0 : data.date) || moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD"),
        email: data === null || data === void 0 ? void 0 : data.email,
        fullName: data === null || data === void 0 ? void 0 : data.fullName,
        formURL: path,
        invendrDetails: {
            callpotentialLeadSource: (invendr === null || invendr === void 0 ? void 0 : invendr.active_rule) || "",
            mediaNumber: ((ref = document.querySelector(".headerPhone")) === null || ref === void 0 ? void 0 : ref.innerText) || "",
            invendrSource: (invendr === null || invendr === void 0 ? void 0 : invendr.source) || "",
            invendrCampaign: (invendr === null || invendr === void 0 ? void 0 : invendr.campaign) || "",
            invendrMedium: (invendr === null || invendr === void 0 ? void 0 : invendr.medium) || "",
            invendrContent: (invendr === null || invendr === void 0 ? void 0 : invendr.content) || "",
            invendrTerm: (invendr === null || invendr === void 0 ? void 0 : invendr.term) || ""
        },
        message: data === null || data === void 0 ? void 0 : data.description,
        phone: data === null || data === void 0 ? void 0 : data.phone,
        preferredLanguage: locale,
        prefersContactBy: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PREFERS_CONTACT_BY */ .bD,
        reCaptchaAction: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECAPTCHA_CALLMEBACK */ .Pi,
        reCaptchaToken: token,
        unitDimensions: unitDimensions || "",
        unitRate: unitRate || "",
        unitRateFrequency: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .UNIT_FREQUENCY */ .$4
    };
};
var makeCallBackRequest = function(data, token, path, facilityId, unitRate, unitDimensions, ero) {
    var locale = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "fr", unitTypeId = arguments.length > 8 ? arguments[8] : void 0, PromotionSLName = arguments.length > 9 ? arguments[9] : void 0, promotionDescription = arguments.length > 10 ? arguments[10] : void 0, consessionId = arguments.length > 11 ? arguments[11] : void 0, unitWidth = arguments.length > 12 ? arguments[12] : void 0, unitLength = arguments.length > 13 ? arguments[13] : void 0, storeType = arguments.length > 14 && arguments[14] !== void 0 ? arguments[14] : "ss", action = arguments.length > 15 && arguments[15] !== void 0 ? arguments[15] : _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECAPTCHA_CALLMEBACK */ .Pi;
    var ref;
    var invendr =  true && window.invendrData;
    return {
        ero: ero,
        dateNeeded: (data === null || data === void 0 ? void 0 : data.date) || moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD"),
        email: data === null || data === void 0 ? void 0 : data.email,
        fullName: data === null || data === void 0 ? void 0 : data.fullName,
        formURL: path,
        invendrDetails: {
            callpotentialLeadSource: (invendr === null || invendr === void 0 ? void 0 : invendr.active_rule) || "",
            mediaNumber: ((ref = document.querySelector(".headerPhone")) === null || ref === void 0 ? void 0 : ref.innerText) || "",
            invendrSource: (invendr === null || invendr === void 0 ? void 0 : invendr.source) || "",
            invendrCampaign: (invendr === null || invendr === void 0 ? void 0 : invendr.campaign) || "",
            invendrMedium: (invendr === null || invendr === void 0 ? void 0 : invendr.medium) || "",
            invendrContent: (invendr === null || invendr === void 0 ? void 0 : invendr.content) || "",
            invendrTerm: (invendr === null || invendr === void 0 ? void 0 : invendr.term) || ""
        },
        message: data === null || data === void 0 ? void 0 : data.description,
        phone: data === null || data === void 0 ? void 0 : data.phone,
        preferredLanguage: locale,
        prefersContactBy: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PREFERS_CONTACT_BY */ .bD,
        reCaptchaAction: action,
        reCaptchaToken: token,
        unitDimensions: unitDimensions,
        unitRate: unitRate || "",
        unitRateFrequency: storeType === "ps" ? _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PORTABLE_UNIT_FREQUENCY */ .GP : _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .UNIT_FREQUENCY */ .$4,
        facilityId: facilityId,
        unitTypeId: unitTypeId,
        PromotionSLName: PromotionSLName,
        promotionDescription: promotionDescription,
        consessionId: consessionId,
        unitWidth: unitWidth,
        unitLength: unitLength
    };
};
var makeTeamCanadaRequest = function(data, token, path) {
    var locale = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "fr";
    var ref;
    var invendr =  true && window.invendrData;
    return {
        dateNeeded: data === null || data === void 0 ? void 0 : data.date,
        email: data === null || data === void 0 ? void 0 : data.email,
        fullName: data === null || data === void 0 ? void 0 : data.fullName,
        formURL: path,
        invendrDetails: {
            callpotentialLeadSource: (invendr === null || invendr === void 0 ? void 0 : invendr.active_rule) || "",
            mediaNumber: ((ref = document.querySelector(".headerPhone")) === null || ref === void 0 ? void 0 : ref.innerText) || "",
            invendrSource: (invendr === null || invendr === void 0 ? void 0 : invendr.source) || "",
            invendrCampaign: (invendr === null || invendr === void 0 ? void 0 : invendr.campaign) || "",
            invendrMedium: (invendr === null || invendr === void 0 ? void 0 : invendr.medium) || "",
            invendrContent: (invendr === null || invendr === void 0 ? void 0 : invendr.content) || "",
            invendrTerm: (invendr === null || invendr === void 0 ? void 0 : invendr.term) || ""
        },
        message: data === null || data === void 0 ? void 0 : data.description,
        phone: data === null || data === void 0 ? void 0 : data.phone,
        preferredLanguage: locale,
        prefersContactBy: data === null || data === void 0 ? void 0 : data.prefer,
        reCaptchaAction: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .RECAPTCHA_TEAM_CANADA */ .B,
        reCaptchaToken: token,
        unitRateFrequency: _utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .UNIT_FREQUENCY */ .$4,
        organization: data === null || data === void 0 ? void 0 : data.national,
        status: data === null || data === void 0 ? void 0 : data.status,
        province: data === null || data === void 0 ? void 0 : data.province
    };
};
/* Referral form */ var makeReferralRequest = function(data, token) {
    return {
        fullName: data === null || data === void 0 ? void 0 : data.fullName,
        email: data === null || data === void 0 ? void 0 : data.email,
        phone: data === null || data === void 0 ? void 0 : data.phone,
        brand: (data === null || data === void 0 ? void 0 : data.brand) || "as",
        lcode: data === null || data === void 0 ? void 0 : data.lcode,
        reCaptchaToken: token
    };
};


/***/ })

}]);